import { useCallback } from "react";
import useSWR from "swr";
import { Paginated } from "../../types";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { CarTaskLog, UpsertCarTaskLog } from "./types";

export const useCarTaskLogsApi = () => {
  const api = useApi();

  const useCarTaskHistory = useCallback(
    (signal: AbortSignal, carTaskID: string) => {
      const url = carTaskID ? `/admin/car_tasks/${carTaskID}/logs` : null;
      return useSWR<Paginated<CarTaskLog> | null, CustomError, string>(url!, (url) =>
        api.get<Paginated<CarTaskLog>>({ url, signal }),
      );
    },
    [api],
  );

  const insertAdminCarTaskLog = useCallback(
    async (carTaskId: string, body: UpsertCarTaskLog, carId: string): Promise<void> => {
      const url = `/admin/car_tasks/${carTaskId}/logs`;

      await api.postNoResult<UpsertCarTaskLog>(url, body);
      api.mutateCache([
        url,
        `/admin/car_tasks`,
        `/admin/car_tasks/${carTaskId}/logs`,
        `/admin/car_tasks/${carTaskId}/overview`,
        `/admin/cars/${carId}/tasks`,
        `/admin/car_tasks/status`,
        `/admin/cars/notifications`,
      ]);
    },
    [api],
  );

  return {
    insertAdminCarTaskLog,
    useCarTaskHistory,
  };
};
